var selectedTimeZone = '';
var selectedEmployee = '';
var selectedInput = '';
function addClearButton() {
    am.$('.select2-search__field').after('<span class="select2-search__clear">✕</span>');
    toggleSearchInputClearElementDynamically();
}

function addClickHandler(selectElement) {
    am.$('.select2-search__clear').on('click', function () {
        am.$('.select2-search__field').val('').focus();
        selectElement.select2('close').select2('open');
        toggleSearchInputClearElementDynamically();
    });
}

function toggleSearchInputClearElementDynamically() {
    if (am.$('.select2-search__field').val()) {
        am.$('.select2-search__clear').removeClass('d-none');
    } else {
        am.$('.select2-search__clear').addClass('d-none');
    }
}

function addSearchInputHandler() {
    am.$('.select2-search__field').on('input', function () {
        toggleSearchInputClearElementDynamically();
    });
}
am.$(function () {
    am.$('.am-select2').select2({
        ajax: {
            delay: 250,
            cache: true
        }
    });

    // Auto-select when company search narrows to a single result
    am.$('#company_id').on('select2:open', function() {
        var $el = am.$(this);
        var observer = new MutationObserver(function() {
            var $results = am.$('.select2-results__option[role="option"]').not('.select2-results__option--load-more');
            var companyResults = [];
            $results.each(function() {
                var $opt = am.$(this);
                if (!$opt.hasClass('select2-results__option--group') && $opt.attr('id')) {
                    var text = $opt.text().trim();
                    if (text !== 'Retail Order') {
                        companyResults.push($opt);
                    }
                }
            });
            if (companyResults.length === 1) {
                companyResults[0].trigger('mouseup');
            }
        });
        setTimeout(function() {
            var dropdown = document.querySelector('.select2-results__options');
            if (dropdown) {
                observer.observe(dropdown, { childList: true, subtree: true });
            }
        }, 100);
        $el.one('select2:close', function() { observer.disconnect(); });
    });

    timeZoneIdRelatedFunctions();

    am.$('#timezone').select2({
        closeOnSelect: true,
        dropdownCssClass: 'am-select2-dropdown-light',
        selectionCssClass: 'select-light-theme',
    });

    timeCardUserSelectFunctionality();

    // countries with lazy loading
    const $countrySelects = document.querySelectorAll('select[data-am-country]');

    if ($countrySelects.length > 0) {
        new Ajax.Request('/ajax/countries/all/', {
            onSuccess:  function (res) {
            const data = res.responseJSON;
            let options = [];

            data.forEach(function (o) {
                const option = document.createElement('option')
                option.value = o.name;
                option.innerText = o.name;
                options.push(option.outerHTML); //<option value="...">...</option>
            });

            $countrySelects.forEach(function (element) {
                element.innerHTML = options.join('');
                const value = element.getAttribute('data-am-country');
                if (value) {
                    am.$(element).val(value).change();
                }
            });
        }
        });
    }
    
});

am.$(document).on('select2:open', () => {
    const searchField = document.querySelector('.select2-container--open .select2-search__field');
    if (searchField) {
        // dropdown searches carry the filter placeholder unless the page set its own
        if (!searchField.placeholder) searchField.placeholder = get_language_translation('LANG_NAVBAR_SEARCH');
        searchField.focus();
    }

    if(am.$(".select2--sales-tax-presence").length > 0){
        am.$('#custom_select2_search').val('');
        am.$('.select2-selection__clear').hide();
    }
});

am.$(document).on('select2:close', () => {
    const $salesTax = am.$(".select2--sales-tax-presence");
    if($salesTax.length > 0 && $salesTax.hasClass('select2-container--tax-presence-open'))
        $salesTax.removeClass('select2-container--tax-presence-open').css('border-radius', '4px');
});

am.$('#timezone, #timezone_id, #timecard_user').on('select2:open', function() {
    am.$('#timezone_id .select2-results').css('opacity', '0');
    document.querySelector('.select2-container--open .select2-search__field').focus();

    if(am.$(".select2--sales-tax-presence").length > 0){
        am.$('#custom_select2_search').val('');
        am.$('.select2-selection__clear').hide();
    }

    am.$('#timezone').on('select2:select', selectEvent => setSelectedTimeZone(selectEvent.target.value));
    am.$('#timezone_id').on('select2:select', selectEvent => setSelectedTimeZone(selectEvent.target.value));
    handleScrollWhenClickedOnTheBottom();
});

handleScrollWhenClickedOnTheBottom = () => {
    if (am.$('#timezone_id').length === 0) return;
    setTimeout(() => {
        if (am.$('.select2-results')[0].style.opacity === '0') {
            am.$('.select2-results').css('opacity', '1');
            am.$(document).find('.select2-results__group').addClass('cursor-pointer').siblings().toggle();
            scrollToSelectedDynamicValueGroup(
              null,
              true,
              am.$('.select2-results').find('ul').attr('id').split('-')[1]
            )
        }
    }, 500);
}

am.$(document).on('select2:close', () => {
    const $salesTax = am.$(".select2--sales-tax-presence");
    if($salesTax.length > 0 && $salesTax.hasClass('select2-container--tax-presence-open'))
        $salesTax.removeClass('select2-container--tax-presence-open').css('border-radius', '4px');
});

am.$(document).on('click', '.select2-results__group', resultGroup => {
    if (am.$('#timezone_id').length === 0) return;
    const resultGroupTarget = resultGroup.target;
    am.$(resultGroupTarget)[0].classList.toggle('expanded');
    am.$(resultGroupTarget).siblings().toggle();
    if (resultGroupTarget.classList.contains('expanded') && selectedTimeZone.includes(resultGroupTarget.innerText)) {
        scrollToSelectedTimeZoneElement();
    }
});

implementCollapsibleForSelectOptGroup = () => {
    if (am.$('#timezone_id').length === 0) return;
    am.$(document)
      .on('click', '.select2-container', resultGroup => {
          am.$('.select2-results').css('opacity', '1');
          let dynamicTimeZoneIdentifier = resultGroup.target.children[0] ? resultGroup.target.children[0].id: resultGroup.target.id;

          if (!dynamicTimeZoneIdentifier) {
              // if clicked from the dropdown arrow
              if (resultGroup.target.getAttribute('role') === 'presentation') {
                  if (resultGroup.target.parentElement.previousElementSibling) {
                      dynamicTimeZoneIdentifier = resultGroup.target.parentElement.previousElementSibling.id;
                  }

                  else if (resultGroup.target.parentElement.firstChild) {
                      dynamicTimeZoneIdentifier = resultGroup.target.parentElement.firstChild.id;
                  }
              }
          }

          const formattedDynamicId = dynamicTimeZoneIdentifier.split('-')[1];
          const inputElement = document.querySelector('input[aria-controls="select2-' + formattedDynamicId + '-results"]');
          if (inputElement) {
              inputElement.placeholder = getDynamicPlaceHolder(formattedDynamicId);
          }
          const resultId = '#select2-' + formattedDynamicId + '-results';
          am.$(resultId).find('.select2-results__group').addClass('cursor-pointer').siblings().toggle();
          setTimeout(() => scrollToSelectedDynamicValueGroup(resultGroup, false, formattedDynamicId));
      });
};

implementCollapsibleForSelectOptGroup();

scrollToSelectedDynamicValueGroup = (resultGroup, forceScroll = false, currentSelectElement) => {
    const dynamicSelectElementValue = selectedTimeZone || selectedEmployee;
    let isFromSelectGroupParent = '';
    if (resultGroup) {
        isFromSelectGroupParent = resultGroup.target.classList.contains('select2-results__group');
    }

    if ((dynamicSelectElementValue && !isFromSelectGroupParent) || forceScroll) {
        let selectedElementParent = '';
        selectedElementParent = getSelectedElementParent(currentSelectElement);
        if (currentSelectElement === 'timecard_user') {
            selectedElementParent[0].style.display = 'block';
        }

        if (dynamicSelectElementValue) {
            if (currentSelectElement !== 'timecard_user') {
                am.$(selectedElementParent).click();
            }
            scrollToSelectedTimeZoneElement();
        }

        return;
    }

    if (!dynamicSelectElementValue) {
        expandDefaultGroup(currentSelectElement);
    }
}

scrollToSelectedTimeZoneElement = () => {
    if (selectedTimeZone) {
        am.$('.select2-results__option').each((index, liRow) => {
            if ($(liRow).innerText.includes(selectedTimeZone)) {
                liRow.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
            }
        });
    }
}

expandDefaultGroup = (currentSelectElement) => {
    if (currentSelectElement === 'timecard_user') {
        am.$('.select2-results__options')[1].style.display = 'block'
    }
}

getSelectedElementParent = (currentElement) => {
    let elementParent = null;
    if (currentElement === 'timecard_user') {
        am.$('strong.select2-results__group').each(function() {
            const strongEl = this;
            const selectedEmployeeId = am.$('#timecard_user').val();
            const parentLi = am.$(strongEl).closest('li.select2-results__option--group');
            const matchingOption = parentLi.find('li.select2-results__option').filter(function() {
                return am.$(this).text().trim().includes(selectedEmployee) &&
                  selectedEmployeeId === am.$(this).attr('id').split('-').pop();
            });

            if (matchingOption.length) {
                elementParent = am.$(this).next('ul');
            }
        });

        return elementParent;
    } else {
        for (const element of am.$('.select2-results__group')) {
            if (element.textContent.trim() === selectedTimeZone.split('/')[0]) {
                elementParent = element;
                break;
            }
        }

        return elementParent
    }
}

scrollToSelectedTimeZoneElement = () => {
    const dynamicSelectElementValue = selectedTimeZone || selectedEmployee;
    if (dynamicSelectElementValue) {
        am.$('.select2-results__option').each((index, liRow) => {
            if ($(liRow).innerText.includes(dynamicSelectElementValue)) {
                liRow.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
            }
        });
    }
}

setSelectedTimeZone = timeZoneValue => selectedTimeZone = timeZoneValue;

function timeCardUserSelectFunctionality() {
    const time_card_user_select_element = am.$('#timecard_user');
    time_card_user_select_element.select2({
        closeOnSelect: true,
    });

    let time_card_handler_attached = false;
    time_card_user_select_element.on('select2:open', function () {
        if (!time_card_handler_attached) {
            setTimeout(function () {
                addClearButton();
                addClickHandler(time_card_user_select_element);
                addSearchInputHandler();
                time_card_handler_attached = true;
            });
        }
    });
}

setEmployee = (employeeValue) => selectedEmployee = employeeValue;

timeZoneIdRelatedFunctions = () => {
    var timeZoneIdInitializeObject = {
        closeOnSelect: true,
        dropdownCssClass: 'am-select2-dropdown-light',
        selectionCssClass: 'select-light-theme'
    };

    // there was a very wierd issue on the individual/new page and contact page,
    // so I had to explicitly set the dropdownParent.
    if (
      window.location.href.include('individual/new') ||
      window.location.href.include('/accounts/contacts/edit/') ||
      window.location.href.include('/accounts/individual/edit/')
    ) {
        timeZoneIdInitializeObject.dropdownParent = am.$('#user_account_inner')[0];
    }

    am.$('#timezone_id').select2(timeZoneIdInitializeObject);

    am.$('#timezone_id').on('select2:open', function(clickedElement) {
        var dynamicElementId = 'select2-' + clickedElement.target.id + '-container';
        var MINIMUM_TOP_SPACE_FOR_THE_SELECT2_CONTAINER_TO_WORK = 308;
        if (getDistanceFromTop(dynamicElementId) < MINIMUM_TOP_SPACE_FOR_THE_SELECT2_CONTAINER_TO_WORK) {
            document.getElementById('user_account').classList.add('force-dropdown-to-below');
        }
    });

    am.$('#timezone_id').on('select2:close', function() {
        document.getElementById('user_account')?.classList.remove('force-dropdown-to-below');
    });
}

getDistanceFromTop = (dynamicElementId) =>  document.getElementById(dynamicElementId).getBoundingClientRect().top

getDynamicPlaceHolder = (formattedDynamicId) => {
    let placeholder = get_language_translation('LANG_NAVBAR_SEARCH');

    if (formattedDynamicId === 'company_id')
        placeholder = get_language_translation('LANG_NAVBAR_SEARCH') + ' ' +  get_language_translation('LANG_LABEL_COMPANY');

    return placeholder;
}

detect_result_option_clicked = () => {
    if (selectedInput){
        am.$('#' + selectedInput).on('select2:select', function(e) {
            if (selectedInput === 'timecard_user') {
                selectedEmployee = e.params.data.text.replace(/\s+/g, ' ').trim();
            }
        });
    }
}

setSelectedInput = (selectedInputParam) => {
    selectedInput = selectedInputParam;
    detect_result_option_clicked();
}
